// extracted by mini-css-extract-plugin
export default {"checkbox":"AbstractProductEditStep4_checkbox__3JALI"};